
import PageHeader from "app/shared/PageHeader";
import "../../Integrations.scss";
import { Tooltip } from 'antd';
import { Tabs, Tag, Button, Skeleton } from "antd";
import Typography from "app/shared/Typography";
import { colorPicker } from "app/utils/color.helper";
import { PlusOutlined, LinkOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { userInfo } from "app/config/States/users";
import axios from "axios";
import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import DonutGST from "../Donut/Donut";
import { FinkTrack } from '../../../../utils/Analytics';
import { API_ENDPOINT_CREDENTIAL_COUNT_GST, API_ENDPOINT_CREDENTIAL_COUNT_EMAIL, API_ENDPOINT_CREDENTIAL_COUNT_AIRLINE } from "app/scenes/IntegrationNew/integrationnew.constants";
// @ts-ignore
import Tour from 'reactour'
import { FinkAnalytics } from "app/utils/GoogleAnalytics";
export default function AllIntegrations(props: any) {
  const countMissingPortalId = (props.data.air || []).reduce(
    (count: any, item: any) => {
      return item.portal_id === null ? count + 1 : count;
    },
    0
  );

  const countMissingSSREmails = (props.data.email || []).reduce(
    (count: any, item: any) => {
      return item.ssr_email === null ? count + 1 : count;
    },
    0
  );
  const [userDetails, setUserDetails] = useRecoilState<any>(userInfo);
  const [gstCredStatusCounts, setGstCredStatusCounts] = useState<Array<{ status: string; count: string }>>([]);
  const [counts, setCounts] = useState<any[]>([]);
  const [amountAtRisk, setAmountAtRisk] = useState(0);//new--
  const [countsEmail, setCountsEmail] = useState<any[]>([]);
  const [amountAtRiskEmail, setAmountAtRiskEmail] = useState(0);//new--
  const [isLoading, setIsLoading] = useState(true);

  type AirlineStatus = {
    valid: boolean | null;
    count: string;
  };
  type GSTStatus = {
    status: string;
    count: string;
  };
  type EmailStatus = {
    status: string | null;
    count: string;
  };

  
  const transformAirline = (
    data: Array<{ status: string; count: number | string }>
  ) =>
    data.map(({ status, count }) => {
      let color = "#FFB30099"; // default for Not Available (yellow)
  
      if (status === "Valid") {
        color = "#4CAF5099"; // green
      } else if (status === "Wrong Credential") {
        color = "#E5393599"; // red
      }
  
      return {
        category: status,
        value: Number(count), // ensure numeric
        color,
      };
    });
  




  const fetchCredsStatusCountsGST = async () => {
    console.log("Inside fetchCredsStatusCounts");
    const workspace_id = userDetails?.currentWorkspace?.id;
    const workspace = userDetails?.currentWorkspace?.name;
    console.log(userDetails?.currentWorkspace, "workspaceId")
    try {
      const response = await axios.post(API_ENDPOINT_CREDENTIAL_COUNT_GST, { workspace_id, workspace },
        //const response = await axios.post("http://localhost:7001/api/creds/gstportal/credsCountGST",{workspace_id,workspace},
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      );

      if (response.data.success) {
        console.log("Status counts:", response.data.data);
        // return response.data.data; 
        setGstCredStatusCounts((response.data.data));
      } else {
        console.error("Failed to fetch status counts:", response.data.message);
        return [];
      }
    } catch (error) {
      console.error("Error fetching status counts:", error);
      return [];
    }
  };
  const fetchCredsStatusCountsEmail = async () => {
    console.log("Inside fetchCredsStatusCounts");
    const workspace_id = userDetails?.currentWorkspace?.id;
    //const workspace_id= '847c5255-d028-4d3d-a757-cb1c926a29ec'; 
    const workspace = userDetails?.currentWorkspace?.name;
    console.log(userDetails?.currentWorkspace?.id, "workspaceId")
    try {
       const response = await axios.post(API_ENDPOINT_CREDENTIAL_COUNT_EMAIL, { workspace_id, workspace },
         //const response = await axios.post('http://localhost:7001/api/creds/email/credsCountEmail',{ workspace_id,workspace} ,
        //const response = await axios.post('http://192.168.0.144:7001/api/creds/email/credsCountEmail',{ workspace_id} ,
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      );

      if (response.data.success) {
        console.log("Status counts:", response.data.data);
        // return response.data.data; 
        setCountsEmail((response.data.data));
        setAmountAtRiskEmail(response.data.totalAmountAtRisk || 0);
      } else {
        console.error("Failed to fetch status counts:", response.data.message);
        return [];
      }
    } catch (error) {
      console.error("Error fetching status counts:", error);
      return [];
    }
  };
  const fetchCredsStatusCountsAirline = async () => {
    console.log("Inside fetchCredsStatusCounts");
    const workspace_id = userDetails?.currentWorkspace?.id;
    const workspace = userDetails?.currentWorkspace?.name;
    console.log(userDetails?.currentWorkspace?.id, "workspaceId")
    try {
       const response = await axios.post(API_ENDPOINT_CREDENTIAL_COUNT_AIRLINE, { workspace_id, workspace },
        //const response = await axios.post('http://localhost:7001/api/creds/airline/credsCountAirline',{ workspace_id, workspace} ,
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      );

      if (response.data.success) {
        console.log("Status counts:", response.data.data);
        // return response.data.data; 
        setCounts((response.data.data));
        setAmountAtRisk(response.data.totalAmountAtRisk || 0);
      } else {
        console.error("Failed to fetch status counts:", response.data.message);
        return [];
      }
    } catch (error) {
      console.error("Error fetching status counts:", error);
      return [];
    }
  };
  

  useEffect(() => {
    const fetchAllData = async () => {
      try {
        await Promise.all([
          fetchCredsStatusCountsGST(),
          fetchCredsStatusCountsEmail(),
          fetchCredsStatusCountsAirline()
        ]);
      } catch (error) {
        console.error("Error fetching credential data:", error);
      } finally {
        setIsLoading(false); // ⏹️ Stop the Skeleton after data is fetched
      }
    };

    fetchAllData();
  }, []);


  const navigate = useNavigate();
  const [isTourOpen, setIsTourOpen] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const Steps = [
    {
      selector: '#gstCreds', // <-- using the id selector
      content: 'GST credentials are your login details to access GST portals and fetch real-time data like GSTR-2B and GSTR-2A data to ensure that your 2A vs Invoice reconciliation reports are at 100%.',
      position: 'top',
    },
    {
      selector: '#airlineCreds', // <-- using the id selector
      content: 'Airlines like Air India, Air France, KLM, Vistara, Lufthansa require us to login to their portals to request invoices, please ensure the login credentials are up to date.',
      position: 'top',
    },
    {
      selector: '#SSRCreds', // <-- using the id selector
      content: 'SSR credentials are email IDs used for booking, this is usually where your airline carrier share the invoices once we request. Update these credentials for smooth invoice management.',
      position: 'top',
    },
  ];

 

  const gstData = gstCredStatusCounts.map(item => ({
    category:
      item.status === null || item.status === "UNKNOWN"
        ? "Not Available"
        : item.status === "INVALID"
        ? "Wrong Credential"
        : item.status === "EXCEPTION"
        ? "Error Verifying"
        : item.status === "ACTIVE"
        ? "Valid"
        : item.status === "LOCKED"
        ? "LOCKED"
        : item.status.toUpperCase(),
    value: Number(item.count ?? 0),
  }));
  
  

  
  const statusColorMap: Record<string, string> = {
    "VALID": "#4CAF5099",             // Green
    "WRONG CREDENTIAL": "#E5393599",  // Red
    "NOT AVAILABLE": "#FFB30099",     // Yellow
  };
  
  const emailData = countsEmail.map(item => {
    const rawStatus = (item.status || "").trim().toUpperCase();
  
    let category: string;
  
    if (rawStatus === "VALID") {
      category = "VALID";
    } else if (rawStatus === "WRONG CREDENTIAL") {
      category = "WRONG CREDENTIAL";
    } else if (rawStatus === "NOT AVAILABLE" || rawStatus === "") {
      category = "NOT AVAILABLE";
    } else {
      category = "NOT AVAILABLE"; // default fallback
    }

    
  
    return {
      category: category
        .split(" ")
        .map(word => word[0] + word.slice(1).toLowerCase())
        .join(" "), // For display as "Valid", "Wrong Credential", etc.
      value: Number(item.count),
      color: statusColorMap[category],
    };
  });
  

 
  const formatIndianNumber = (num: number): string => {
    const format = (val: number) =>
      val % 1 === 0 ? val.toFixed(0) : val.toFixed(2);
  
    if (num >= 10000000) {
      return `${format(num / 10000000)} Cr`;
    } else if (num >= 100000) {
      return `${format(num / 100000)} L`;
    } else {
      return num.toLocaleString("en-IN", {
        minimumFractionDigits: num % 1 === 0 ? 0 : 2,
        maximumFractionDigits: 2,
      });
    }
  };
  


  //const invalidCount = gstCredStatusCounts.find(item => item.status === "INVALID")?.count || 0;
  const totalExceptActive = gstCredStatusCounts.reduce((sum, item) => {
    if (item.status !== "ACTIVE") {
      return sum + Number(item.count ?? 0);
    }
    return sum;
  }, 0);

  

  const handleGstCredentialCardClick = (cardType: string, totalExceptActive: number) => {
    const hasPending = totalExceptActive > 0;
  
    console.log(`📊 PostHog: Clicked on ${cardType} card`);
    const eventProperties = {
      card_type: "GST",
      section: "credentials",
      has_pending_action: hasPending,
      pending_action_count: totalExceptActive,
      workspace_name: userDetails?.currentWorkspace?.name || "unknown",
      user_id: userDetails?.id,
      subdomain: window.location.hostname.split('.')[0],
      timestamp: new Date().toISOString(),
      valid_count: gstCredStatusCounts.find(item => item.status === "ACTIVE")?.count || "0",
      invalid_count: totalExceptActive
    };
  
    FinkAnalytics("user_clicked_gst_card", {
      ...eventProperties,
      event_type: "card_click",
      interaction_type: "click"
    });
  
    // Track pending action status
    FinkAnalytics("user_has_pending_action_inGST", {
      ...eventProperties,
      event_type: "status_check",
      pending_action_status: hasPending ? "yes" : "no",
      action_required: totalExceptActive > 0 ? "yes" : "no"
    });
  };
  
  
  const handleAirlineCredentialCardClick = (cardType: string, amountAtRisk: number) => {

    const hasPending = amountAtRisk > 0;

    console.log(`📊 PostHog: Clicked on ${cardType} card`);
    FinkAnalytics("user_clicked_airline_card", {
      card_type: "Airline",
      section: "credentials",
      has_pending_action: hasPending,
    });

    FinkAnalytics("user_has_pending_action_inAirline", {
      card_type: "Airline",
      section: "credentials",
      pending_action_status: hasPending ? "yes" : "no",
    });
  };
  
  const handleEmailCredentialCardClick = (cardType: string, amountAtRiskEmail: number) => {
    
    const hasPending = amountAtRiskEmail > 0;
    console.log(`📊 PostHog: Clicked on ${cardType} card`);

    FinkAnalytics("user_clicked_email_card", {
      card_type: "Email",
      section: "credentials",
      has_pending_action: hasPending,
    });

    FinkAnalytics("user_has_pending_action_inEmail", {
      card_type: "Email",
      section: "credentials",
      pending_action_status: hasPending ? "yes" : "no",
    });
  };
  
  
 
  return (
    <div className="CardList">
      {/* GST Credential Card */}
      <div className="IntegrationCard" 
      onClick={() => {
        handleGstCredentialCardClick("GST", totalExceptActive); // Moved analytics here
        props.onSelect("2");
      }}>
        <div className="CardTopContainer">
          <div className="cardTopHeaderSection">
            <h2 className="headerTextGST">GST Credential</h2>
            <InfoCircleOutlined
              id="gstCreds"
              onClick={(e) => {
                e.stopPropagation();
                setCurrentStep(0);
                setIsTourOpen(true);
              }}
              style={{ marginLeft: '12px', color: '#999999' }}
            />
          </div>
        </div>
        <div
          className="CardDescription"
          style={
            isLoading
              ? { display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }
              : undefined
          }
        >
          <Skeleton
            loading={isLoading}
            active
            paragraph={{ rows: 2, width: ['150px', '200px'] }}
            style={{ width: '250px' }}
          >
            <div className="amountRiskLeftSection">
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span className="amtAtRiskText">Action Required:</span>
                <strong className="amountNum">{totalExceptActive}</strong>
              </div>
              <Button className="actnBtn">Take Action</Button>
            </div>
            <div style={{ width: 190, height: '190px' }}>
              <DonutGST data={gstData} />
            </div>
          </Skeleton>
        </div>

      </div>

      {/* Airline Credential Card */}
      <div className="IntegrationCard" 
      onClick={() => {
        handleAirlineCredentialCardClick("Airline", amountAtRisk);
        props.onSelect("3")}}
        >
        <div className="CardTopContainer">
          <div className="cardTopHeaderSection">
            <h2 className="headerTextGST">Airline Credential</h2>
            <InfoCircleOutlined
              id="airlineCreds"
              onClick={(e) => {
                e.stopPropagation();
                setCurrentStep(1);
                setIsTourOpen(true);
              }}
              style={{ marginLeft: '12px', color: '#999999' }}
            />
          </div>
        </div>
        <div className="CardDescription"
        style={
          isLoading
            ? { display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }
            : undefined
        } >
          <Skeleton
            loading={isLoading}
            active
            paragraph={{ rows: 2, width: ['150px', '200px'] }}
            style={{ width: '250px' }}
          >
            <div className="amountRiskLeftSection">
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span className="amtAtRiskText">Total amount at risk:</span>
                {/* <strong className="amountNum">₹ {amountAtRisk.toLocaleString('en-IN')}</strong> */}
                <strong className="amountNum">₹ {formatIndianNumber(amountAtRisk)}</strong>
              </div>
              <Button  className="actnBtn">Take Action</Button>
            </div>
            <div style={{ width: 190, height: '190px' }}>
              <DonutGST data={transformAirline(counts)} />
            </div>
          </Skeleton>
        </div>
      </div>

      {/* SSR Credential Card */}
      <div className="IntegrationCard"
      onClick={() => {
        handleEmailCredentialCardClick("SSR", amountAtRiskEmail);
        props.onSelect("4")}}
        >
        <div className="CardTopContainer">
          <div className="cardTopHeaderSection">
            <h2 className="headerTextGST">SSR Credential</h2>
            <InfoCircleOutlined
              id="SSRCreds"
              onClick={(e) => {
                e.stopPropagation();
                setCurrentStep(2);
                setIsTourOpen(true);
              }}
              style={{ marginLeft: '12px', color: '#999999' }}
            />
          </div>
        </div>
        <div className="CardDescription" style={
          isLoading
            ? { display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }
            : undefined
        }>
          <Skeleton
            loading={isLoading}
            active
            paragraph={{ rows: 2, width: ['150px', '200px'] }}
            style={{ width: '250px' }}
          >
            <div className="amountRiskLeftSection">
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span className="amtAtRiskText">Total amount at risk:</span>
                <strong className="amountNum">₹ {formatIndianNumber(amountAtRiskEmail)}</strong>
              </div>
              <Button  className="actnBtn">Take Action</Button>
            </div>
            <div style={{ width: 190, height: '190px' }}>
              <DonutGST data={emailData} />
            </div>
          </Skeleton>
        </div>
      </div>

      {/* Ant Design Tour Component */}
      <Tour
        steps={Steps}
        isOpen={isTourOpen}
        onRequestClose={() => setIsTourOpen(false)}
        startAt={currentStep}
        rounded={10}
        styles={{
          maskArea: (base: any) => ({
            ...base,
            borderRadius: 15,
          }),
          overlay: (base: any) => ({
            ...base,
            backgroundColor: "rgba(0,0,0,0.5)",
          }),
        }}
      />
    </div>
  );

  
}










